import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './styles/globals.css';
import App from './App';
import { Toaster } from './components/ui';
import { isApiError } from './lib/api';
import { AuthProvider } from './lib/auth-context';

// Opt-in error reporting: no DSN in the bundle unless the deploy sets one (no secrets in code).
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) void import('@sentry/react').then((S) => S.init({ dsn, environment: import.meta.env.MODE }));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Never retry auth/permission/validation errors; retry transient ones twice.
      retry: (n, e) => (!isApiError(e) || e.status >= 500 || e.code === 'network') && n < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Suspense fallback={null}>
            <App />
          </Suspense>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
